import { useSelector } from 'react-redux'
import { Grid } from '@mui/material';
import { gridSpacing } from '../../store/constant';
import UserForm from '../components/UserForm';


const AddUserPage = () => {
    const customization = useSelector((state) => state.customization);

    return (
        <Grid container spacing={gridSpacing} alignItems="center" sx={{ marginTop: "40px"}}>
            <Grid item xs={12} >
                    {customization.login && (<UserForm />)}
            </Grid>
        </Grid>
    );
};

export default AddUserPage;